import { useEffect, useState } from 'react';
import axios from '../../../api/axiosInstance';
import Loader from './Loader';
import ErrorBox from './ErrorBox';
import dayjs from 'dayjs';

export default function UpcomingEvents({ businessId }) {
  const [events, setEvents] = useState([]);
  const [offset, setOffset] = useState(0);
  const [state, setState] = useState('loading'); // loading | ready | error | empty

  const fetchEvents = (reset = false) => {
    setState('loading');
    axios
      .get('/dashboard/events', {
        params: { business_id: businessId, offset: reset ? 0 : offset },
      })
      .then(({ data }) => {
        setEvents((prev) => (reset ? data : [...prev, ...data]));
        setOffset((prev) => prev + data.length);
        setState(data.length ? 'ready' : 'empty');
      })
      .catch(() => setState('error'));
  };

  useEffect(() => {
    setOffset(0);
    fetchEvents(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [businessId]);

  if (state === 'loading' && !events.length) return <Loader />;
  //if (state === 'error') return <ErrorBox message="Failed to load events." />;
  if (state === 'error') return null;

  return (
    <section className="space-y-4 rounded-lg bg-white p-6 shadow">
      <header className="flex items-center justify-between">
        <h2 className="text-lg font-semibold">Upcoming Events</h2>
        <a
          href={`/business-admin/schedule/calendar?business_id=${businessId}`}
          className="rounded-md bg-blue-600 px-3 py-1 text-sm text-white hover:bg-blue-700"
        >
          + Create Event
        </a>
      </header>

      {events.length === 0 ? (
        <p className="text-sm text-gray-500">No events scheduled.</p>
      ) : (
        <ul className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {events.map((ev) => (
            <li
              key={ev.id}
              className="flex flex-col gap-2 rounded-md border p-4 hover:shadow-sm"
            >
              <span className="font-medium">{ev.title}</span>
              <span className="text-sm text-gray-500">
                {dayjs(ev.start_date).format('MMM D, YYYY')}
              </span>
              <span className="text-sm">👁️ {ev.views ?? 0}</span>
            </li>
          ))}
        </ul>
      )}

      {state === 'ready' && (
        <button
          onClick={() => fetchEvents(false)}
          className="block w-full rounded-md border border-gray-300 bg-white py-1 text-sm hover:bg-gray-100"
        >
          Load more
        </button>
      )}
    </section>
  );
}
